import React from "react";
import Icons from "./Icons";
import { Link } from "react-router-dom";
import { LOCAL_CONTACT_NO, LOCAL_EMAIL } from "../../../utils/defaults";
import Paragraph from "../ui/Paragraph";
const TopNav = () => {
  const classNameLinks =
    "flex gap-1.5 items-center group relative after:absolute after:bottom-0 after:right-0 after:h-[1px] after:bg-white after:w-0 after:transition-all after:duration-300 after:ease-linear hover:after:w-[calc(100%_-_28px)]";
  return (
    <div className="bg-custom-blue-v2">
      <div className=" container py-4 md:py-2 lg:py-3 flex justify-center md:justify-between">
        <Paragraph variant="white" className=" flex gap-1.5 group">
          Call Any Time
          <Link to={`tel:${LOCAL_CONTACT_NO}`} className={classNameLinks}>
            <span>
              <Icons
                className="w-[18px] h-[18px] md:w-6 md:h-6 vibrate-shake"
                icon={"phone"}
              />
            </span>
            {LOCAL_CONTACT_NO}
          </Link>
        </Paragraph>
        <Paragraph variant="white" className="group sm:block hidden">
          <Link to={`mailto:${LOCAL_EMAIL}`} className={classNameLinks}>
            <span>
              <Icons
                className="w-[18px] h-[18px] md:w-6 md:h-6 vibrate-shake"
                icon={"mail"}
              />
            </span>{" "}
            {LOCAL_EMAIL}
          </Link>
        </Paragraph>
      </div>
    </div>
  );
};

export default TopNav;
